import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ContactService } from 'src/app/rest_services/contact.service';

@Component({
  selector: 'app-fiche-contact',
  templateUrl: './fiche-contact.component.html',
  styleUrls: ['./fiche-contact.component.css']
})
export class FicheContactComponent implements OnInit {
    uuid: any;
    constructor(
      private route: ActivatedRoute,
      private contactService: ContactService,
      private router: Router,
    ) { }

  ngOnInit(): void {
    this.uuid = this.route.snapshot.params['uuid'];
    this.retrieveContact(this.uuid);
  }

  contact:any;
  retrieveContactSubscription!:Subscription;
  retrieveContactLoader:boolean = true;
  retrieveContact(uuid:any){
    this.retrieveContactSubscription = this.contactService.getContactDetail(uuid).subscribe(
      (data:any) => {
        this.retrieveContactLoader = false;
        if (data.code == "2eae402f9f4d1fe2c1b2da4287fd47a5"){
          this.contact = data.contact;
        }
        else if (data.code == "70b96ceb00af1d26a71ffbfdf9ebdde6"){
          this.router.navigate(['/contacts'])
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
